import en from "./en.json";
import jp from "./jp.json";

const languages = { en, jp };

export default languages;
